import { User } from 'models';
import { BffResponseObject, ErrorResponse } from 'sources/model/response';

export class UserSource {
  public async createUser(user: User): Promise<BffResponseObject<ErrorResponse<string>>> {
    let resOk = false;
    let resStatusText = null;

    return await fetch('/api/v1/users/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    })
      .then((response) => {
        resOk = response.ok;
        resStatusText = response.statusText;

        return response.json();
      })
      .then((data) => {
        if (resOk) {
          return {
            success: true,
            error: null,
            resBody: null,
          };
        } else {
          return {
            success: false,
            error: resStatusText,
            resBody: data,
          };
        }
      })
      .catch((err) => {
        return {
          success: false,
          error: err.message,
          resBody: null,
        };
      });
  }

  public async sendEmail(email: string, locale: string, emailType: string) {
    return await fetch(`/api/v1/users/${email}/email/${locale}/${emailType}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          return {
            success: true,
            error: null,
          };
        } else {
          return {
            success: false,
            error: response.statusText,
          };
        }
      })
      .catch((err) => {
        return {
          success: false,
          error: err.message,
        };
      });
  }

  public async sendVerificationEmail(email: string, locale: string) {
    return this.sendEmail(email, locale, 'welcome');
  }

  public async sendForgotPasswordEmail(email: string, locale: string) {
    return this.sendEmail(email, locale, 'forgotpassword');
  }

  public async setPassword(password: string) {
    return await fetch('/api/v1/users/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(password),
    })
      .then((response) => {
        if (response.ok) {
          return {
            success: true,
            error: null,
          };
        } else {
          return {
            success: false,
            error: response.statusText,
          };
        }
      })
      .catch((err) => {
        return {
          success: false,
          error: err.message,
        };
      });
  }

  public async verifyUser(email: string) {
    return await fetch(`/api/v1/users/${email}/verify`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((verifyUserResponse) => ({
        success: true,
        body: verifyUserResponse,
      }))
      .catch((error) => ({
        success: false,
        error,
        body: null,
      }));
  }
}
